"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("../Themes/styled-components"));
var Button_1 = __importDefault(require("../Button"));
var Header_1 = __importDefault(require("../Header"));
var Modal_1 = __importStar(require("../Modal"));
var AspectRatioPicker_1 = __importDefault(require("./Settings/AspectRatioPicker"));
var utilities_1 = require("../utilities");
var StyledModalActions = styled_components_1.default(Modal_1.ModalActions)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: auto;\n"], ["\n  margin-top: auto;\n"])));
var Settings = /** @class */ (function (_super) {
    __extends(Settings, _super);
    function Settings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            settings: _this.props.settings,
        };
        _this.handleSubmit = function () {
            _this.props.onSubmit(_this.state.settings);
        };
        _this.handleChangeAspectRatio = function (aspectRatio) {
            _this.setState(function (prevState) {
                return __assign(__assign({}, prevState), { settings: __assign(__assign({}, prevState.settings), { aspectRatio: aspectRatio }) });
            });
        };
        return _this;
    }
    Settings.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isOpen === false && this.props.isOpen === true) {
            this.setState({ settings: this.props.settings });
        }
    };
    Settings.prototype.render = function () {
        var settings = this.state.settings;
        var _a = this.props, isOpen = _a.isOpen, onClose = _a.onClose, availableAspectRatios = _a.availableAspectRatios;
        return (React.createElement(Modal_1.default, { isOpen: isOpen, handleClose: onClose, size: "fullscreen" },
            React.createElement(Modal_1.ModalContent, null,
                React.createElement(Header_1.default, null, utilities_1.__('Pomer strán')),
                React.createElement(AspectRatioPicker_1.default, { value: settings.aspectRatio || null, onChange: this.handleChangeAspectRatio, options: availableAspectRatios })),
            React.createElement(StyledModalActions, null,
                React.createElement(Button_1.default, { basic: true, onClick: onClose }, utilities_1.__('Zrušiť')),
                React.createElement(Button_1.default, { basic: true, primary: true, onClick: this.handleSubmit }, utilities_1.__('Hotovo')))));
    };
    return Settings;
}(React.PureComponent));
exports.default = Settings;
var templateObject_1;
